import { required } from 'vuelidate/lib/validators'

export default {
  provide: function() {
    return {
      $vv: this.$v
    }
  },
  validations: {
    detailGroup: ['entity.jobStage', 'entity.subJobStageId'],
    entity: {
      jobStage: {
        required
      },
      subJobStageId: {
        required
      },
      sortKey:{
        required
      }
    },
    filter: {}
  }
}
